import { ScheduledUserLoading } from '@/views/community/channel/scheduled/user/scheduled-user.loading';

export default ScheduledUserLoading;
